<template>
  <div>
    <homeView></homeView>
    <!--<router-view/>-->
  </div>
</template>
<script>
import homeView from './views/Home'
export default {
  name: 'App',
  components: {
    homeView
  }

}
</script>
<style lang="less">
</style>
